import { jsx as e, css as t } from "@emotion/core";
import n, { useRef as r, useEffect as o } from "react";
import i from "react-dom";

function a() {
  return (a = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }

    return e;
  }).apply(this, arguments);
}

function s(e, t) {
  if (null == e) return {};
  var n,
      r,
      o = {},
      i = Object.keys(e);

  for (r = 0; r < i.length; r++) {
    n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
  }

  return o;
}

function c(e) {
  return (c = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  })(e);
}

function u(e, t) {
  return e(t = {
    exports: {}
  }, t.exports), t.exports;
  /** @license React v16.13.1
   * react-is.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
}

var l = "function" == typeof Symbol && Symbol.for,
    p = l ? Symbol.for("react.element") : 60103,
    f = l ? Symbol.for("react.portal") : 60106,
    d = l ? Symbol.for("react.fragment") : 60107,
    g = l ? Symbol.for("react.strict_mode") : 60108,
    y = l ? Symbol.for("react.profiler") : 60114,
    b = l ? Symbol.for("react.provider") : 60109,
    m = l ? Symbol.for("react.context") : 60110,
    C = l ? Symbol.for("react.async_mode") : 60111,
    v = l ? Symbol.for("react.concurrent_mode") : 60111,
    h = l ? Symbol.for("react.forward_ref") : 60112,
    I = l ? Symbol.for("react.suspense") : 60113,
    A = l ? Symbol.for("react.suspense_list") : 60120,
    x = l ? Symbol.for("react.memo") : 60115,
    E = l ? Symbol.for("react.lazy") : 60116,
    O = l ? Symbol.for("react.block") : 60121,
    N = l ? Symbol.for("react.fundamental") : 60117,
    S = l ? Symbol.for("react.responder") : 60118,
    w = l ? Symbol.for("react.scope") : 60119;

function R(e) {
  if ("object" === c(e) && null !== e) {
    var t = e.$$typeof;

    switch (t) {
      case p:
        switch (e = e.type) {
          case C:
          case v:
          case d:
          case y:
          case g:
          case I:
            return e;

          default:
            switch (e = e && e.$$typeof) {
              case m:
              case h:
              case E:
              case x:
              case b:
                return e;

              default:
                return t;
            }

        }

      case f:
        return t;
    }
  }
}

function Z(e) {
  return R(e) === v;
}

var G = {
  AsyncMode: C,
  ConcurrentMode: v,
  ContextConsumer: m,
  ContextProvider: b,
  Element: p,
  ForwardRef: h,
  Fragment: d,
  Lazy: E,
  Memo: x,
  Portal: f,
  Profiler: y,
  StrictMode: g,
  Suspense: I,
  isAsyncMode: function isAsyncMode(e) {
    return Z(e) || R(e) === C;
  },
  isConcurrentMode: Z,
  isContextConsumer: function isContextConsumer(e) {
    return R(e) === m;
  },
  isContextProvider: function isContextProvider(e) {
    return R(e) === b;
  },
  isElement: function isElement(e) {
    return "object" === c(e) && null !== e && e.$$typeof === p;
  },
  isForwardRef: function isForwardRef(e) {
    return R(e) === h;
  },
  isFragment: function isFragment(e) {
    return R(e) === d;
  },
  isLazy: function isLazy(e) {
    return R(e) === E;
  },
  isMemo: function isMemo(e) {
    return R(e) === x;
  },
  isPortal: function isPortal(e) {
    return R(e) === f;
  },
  isProfiler: function isProfiler(e) {
    return R(e) === y;
  },
  isStrictMode: function isStrictMode(e) {
    return R(e) === g;
  },
  isSuspense: function isSuspense(e) {
    return R(e) === I;
  },
  isValidElementType: function isValidElementType(e) {
    return "string" == typeof e || "function" == typeof e || e === d || e === v || e === y || e === g || e === I || e === A || "object" === c(e) && null !== e && (e.$$typeof === E || e.$$typeof === x || e.$$typeof === b || e.$$typeof === m || e.$$typeof === h || e.$$typeof === N || e.$$typeof === S || e.$$typeof === w || e.$$typeof === O);
  },
  typeOf: R
},
    V = u(function (e, t) {
  "production" !== process.env.NODE_ENV && function () {
    var e = "function" == typeof Symbol && Symbol.for,
        n = e ? Symbol.for("react.element") : 60103,
        r = e ? Symbol.for("react.portal") : 60106,
        o = e ? Symbol.for("react.fragment") : 60107,
        i = e ? Symbol.for("react.strict_mode") : 60108,
        a = e ? Symbol.for("react.profiler") : 60114,
        s = e ? Symbol.for("react.provider") : 60109,
        u = e ? Symbol.for("react.context") : 60110,
        l = e ? Symbol.for("react.async_mode") : 60111,
        p = e ? Symbol.for("react.concurrent_mode") : 60111,
        f = e ? Symbol.for("react.forward_ref") : 60112,
        d = e ? Symbol.for("react.suspense") : 60113,
        g = e ? Symbol.for("react.suspense_list") : 60120,
        y = e ? Symbol.for("react.memo") : 60115,
        b = e ? Symbol.for("react.lazy") : 60116,
        m = e ? Symbol.for("react.block") : 60121,
        C = e ? Symbol.for("react.fundamental") : 60117,
        v = e ? Symbol.for("react.responder") : 60118,
        h = e ? Symbol.for("react.scope") : 60119;

    function I(e) {
      if ("object" === c(e) && null !== e) {
        var t = e.$$typeof;

        switch (t) {
          case n:
            var g = e.type;

            switch (g) {
              case l:
              case p:
              case o:
              case a:
              case i:
              case d:
                return g;

              default:
                var m = g && g.$$typeof;

                switch (m) {
                  case u:
                  case f:
                  case b:
                  case y:
                  case s:
                    return m;

                  default:
                    return t;
                }

            }

          case r:
            return t;
        }
      }
    }

    var A = l,
        x = p,
        E = u,
        O = s,
        N = n,
        S = f,
        w = o,
        R = b,
        Z = y,
        G = r,
        V = a,
        k = i,
        j = d,
        T = !1;

    function P(e) {
      return I(e) === p;
    }

    t.AsyncMode = A, t.ConcurrentMode = x, t.ContextConsumer = E, t.ContextProvider = O, t.Element = N, t.ForwardRef = S, t.Fragment = w, t.Lazy = R, t.Memo = Z, t.Portal = G, t.Profiler = V, t.StrictMode = k, t.Suspense = j, t.isAsyncMode = function (e) {
      return T || (T = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), P(e) || I(e) === l;
    }, t.isConcurrentMode = P, t.isContextConsumer = function (e) {
      return I(e) === u;
    }, t.isContextProvider = function (e) {
      return I(e) === s;
    }, t.isElement = function (e) {
      return "object" === c(e) && null !== e && e.$$typeof === n;
    }, t.isForwardRef = function (e) {
      return I(e) === f;
    }, t.isFragment = function (e) {
      return I(e) === o;
    }, t.isLazy = function (e) {
      return I(e) === b;
    }, t.isMemo = function (e) {
      return I(e) === y;
    }, t.isPortal = function (e) {
      return I(e) === r;
    }, t.isProfiler = function (e) {
      return I(e) === a;
    }, t.isStrictMode = function (e) {
      return I(e) === i;
    }, t.isSuspense = function (e) {
      return I(e) === d;
    }, t.isValidElementType = function (e) {
      return "string" == typeof e || "function" == typeof e || e === o || e === p || e === a || e === i || e === d || e === g || "object" === c(e) && null !== e && (e.$$typeof === b || e.$$typeof === y || e.$$typeof === s || e.$$typeof === u || e.$$typeof === f || e.$$typeof === C || e.$$typeof === v || e.$$typeof === h || e.$$typeof === m);
    }, t.typeOf = I;
  }();
}),
    k = (V.AsyncMode, V.ConcurrentMode, V.ContextConsumer, V.ContextProvider, V.Element, V.ForwardRef, V.Fragment, V.Lazy, V.Memo, V.Portal, V.Profiler, V.StrictMode, V.Suspense, V.isAsyncMode, V.isConcurrentMode, V.isContextConsumer, V.isContextProvider, V.isElement, V.isForwardRef, V.isFragment, V.isLazy, V.isMemo, V.isPortal, V.isProfiler, V.isStrictMode, V.isSuspense, V.isValidElementType, V.typeOf, u(function (e) {
  "production" === process.env.NODE_ENV ? e.exports = G : e.exports = V;
})),
    j = Object.getOwnPropertySymbols,
    T = Object.prototype.hasOwnProperty,
    P = Object.prototype.propertyIsEnumerable;

function W(e) {
  if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
  return Object(e);
}

var H = function () {
  try {
    if (!Object.assign) return !1;
    var e = new String("abc");
    if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;

    for (var t = {}, n = 0; n < 10; n++) {
      t["_" + String.fromCharCode(n)] = n;
    }

    if ("0123456789" !== Object.getOwnPropertyNames(t).map(function (e) {
      return t[e];
    }).join("")) return !1;
    var r = {};
    return "abcdefghijklmnopqrst".split("").forEach(function (e) {
      r[e] = e;
    }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, r)).join("");
  } catch (e) {
    return !1;
  }
}() ? Object.assign : function (e, t) {
  for (var n, r, o = W(e), i = 1; i < arguments.length; i++) {
    for (var a in n = Object(arguments[i])) {
      T.call(n, a) && (o[a] = n[a]);
    }

    if (j) {
      r = j(n);

      for (var s = 0; s < r.length; s++) {
        P.call(n, r[s]) && (o[r[s]] = n[r[s]]);
      }
    }
  }

  return o;
},
    _ = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED",
    J = function J() {};

if ("production" !== process.env.NODE_ENV) {
  var X = _,
      Y = {},
      B = Function.call.bind(Object.prototype.hasOwnProperty);

  J = function J(e) {
    var t = "Warning: " + e;
    "undefined" != typeof console && console.error(t);

    try {
      throw new Error(t);
    } catch (e) {}
  };
}

function F(e, t, n, r, o) {
  if ("production" !== process.env.NODE_ENV) for (var i in e) {
    if (B(e, i)) {
      var a;

      try {
        if ("function" != typeof e[i]) {
          var s = Error((r || "React class") + ": " + n + " type `" + i + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + c(e[i]) + "`.");
          throw s.name = "Invariant Violation", s;
        }

        a = e[i](t, i, r, n, null, X);
      } catch (e) {
        a = e;
      }

      if (!a || a instanceof Error || J((r || "React class") + ": type specification of " + n + " `" + i + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + c(a) + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), a instanceof Error && !(a.message in Y)) {
        Y[a.message] = !0;
        var u = o ? o() : "";
        J("Failed " + n + " type: " + a.message + (null != u ? u : ""));
      }
    }
  }
}

F.resetWarningCache = function () {
  "production" !== process.env.NODE_ENV && (Y = {});
};

var D = F,
    $ = Function.call.bind(Object.prototype.hasOwnProperty),
    L = function L() {};

function M() {
  return null;
}

"production" !== process.env.NODE_ENV && (L = function L(e) {
  var t = "Warning: " + e;
  "undefined" != typeof console && console.error(t);

  try {
    throw new Error(t);
  } catch (e) {}
});

var z = function z(e, t) {
  var n = "function" == typeof Symbol && Symbol.iterator;
  var r = {
    array: s("array"),
    bool: s("boolean"),
    func: s("function"),
    number: s("number"),
    object: s("object"),
    string: s("string"),
    symbol: s("symbol"),
    any: a(M),
    arrayOf: function arrayOf(e) {
      return a(function (t, n, r, o, a) {
        if ("function" != typeof e) return new i("Property `" + a + "` of component `" + r + "` has invalid PropType notation inside arrayOf.");
        var s = t[n];
        if (!Array.isArray(s)) return new i("Invalid " + o + " `" + a + "` of type `" + l(s) + "` supplied to `" + r + "`, expected an array.");

        for (var c = 0; c < s.length; c++) {
          var u = e(s, c, r, o, a + "[" + c + "]", _);
          if (u instanceof Error) return u;
        }

        return null;
      });
    },
    element: a(function (t, n, r, o, a) {
      var s = t[n];
      return e(s) ? null : new i("Invalid " + o + " `" + a + "` of type `" + l(s) + "` supplied to `" + r + "`, expected a single ReactElement.");
    }),
    elementType: a(function (e, t, n, r, o) {
      var a = e[t];
      return k.isValidElementType(a) ? null : new i("Invalid " + r + " `" + o + "` of type `" + l(a) + "` supplied to `" + n + "`, expected a single ReactElement type.");
    }),
    instanceOf: function instanceOf(e) {
      return a(function (t, n, r, o, a) {
        if (!(t[n] instanceof e)) {
          var s = e.name || "<<anonymous>>";
          return new i("Invalid " + o + " `" + a + "` of type `" + function (e) {
            if (!e.constructor || !e.constructor.name) return "<<anonymous>>";
            return e.constructor.name;
          }(t[n]) + "` supplied to `" + r + "`, expected instance of `" + s + "`.");
        }

        return null;
      });
    },
    node: a(function (e, t, n, r, o) {
      return u(e[t]) ? null : new i("Invalid " + r + " `" + o + "` supplied to `" + n + "`, expected a ReactNode.");
    }),
    objectOf: function objectOf(e) {
      return a(function (t, n, r, o, a) {
        if ("function" != typeof e) return new i("Property `" + a + "` of component `" + r + "` has invalid PropType notation inside objectOf.");
        var s = t[n],
            c = l(s);
        if ("object" !== c) return new i("Invalid " + o + " `" + a + "` of type `" + c + "` supplied to `" + r + "`, expected an object.");

        for (var u in s) {
          if ($(s, u)) {
            var p = e(s, u, r, o, a + "." + u, _);
            if (p instanceof Error) return p;
          }
        }

        return null;
      });
    },
    oneOf: function oneOf(e) {
      if (!Array.isArray(e)) return "production" !== process.env.NODE_ENV && (arguments.length > 1 ? L("Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).") : L("Invalid argument supplied to oneOf, expected an array.")), M;

      function t(t, n, r, a, s) {
        for (var c = t[n], u = 0; u < e.length; u++) {
          if (o(c, e[u])) return null;
        }

        var l = JSON.stringify(e, function (e, t) {
          return "symbol" === p(t) ? String(t) : t;
        });
        return new i("Invalid " + a + " `" + s + "` of value `" + String(c) + "` supplied to `" + r + "`, expected one of " + l + ".");
      }

      return a(t);
    },
    oneOfType: function oneOfType(e) {
      if (!Array.isArray(e)) return "production" !== process.env.NODE_ENV && L("Invalid argument supplied to oneOfType, expected an instance of array."), M;

      for (var t = 0; t < e.length; t++) {
        var n = e[t];
        if ("function" != typeof n) return L("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + f(n) + " at index " + t + "."), M;
      }

      return a(function (t, n, r, o, a) {
        for (var s = 0; s < e.length; s++) {
          if (null == (0, e[s])(t, n, r, o, a, _)) return null;
        }

        return new i("Invalid " + o + " `" + a + "` supplied to `" + r + "`.");
      });
    },
    shape: function shape(e) {
      return a(function (t, n, r, o, a) {
        var s = t[n],
            c = l(s);
        if ("object" !== c) return new i("Invalid " + o + " `" + a + "` of type `" + c + "` supplied to `" + r + "`, expected `object`.");

        for (var u in e) {
          var p = e[u];

          if (p) {
            var f = p(s, u, r, o, a + "." + u, _);
            if (f) return f;
          }
        }

        return null;
      });
    },
    exact: function exact(e) {
      return a(function (t, n, r, o, a) {
        var s = t[n],
            c = l(s);
        if ("object" !== c) return new i("Invalid " + o + " `" + a + "` of type `" + c + "` supplied to `" + r + "`, expected `object`.");
        var u = H({}, t[n], e);

        for (var p in u) {
          var f = e[p];
          if (!f) return new i("Invalid " + o + " `" + a + "` key `" + p + "` supplied to `" + r + "`.\nBad object: " + JSON.stringify(t[n], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(e), null, "  "));
          var d = f(s, p, r, o, a + "." + p, _);
          if (d) return d;
        }

        return null;
      });
    }
  };

  function o(e, t) {
    return e === t ? 0 !== e || 1 / e == 1 / t : e != e && t != t;
  }

  function i(e) {
    this.message = e, this.stack = "";
  }

  function a(e) {
    if ("production" !== process.env.NODE_ENV) var n = {},
        r = 0;

    function o(o, a, s, c, u, l, p) {
      if (c = c || "<<anonymous>>", l = l || s, p !== _) {
        if (t) {
          var f = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
          throw f.name = "Invariant Violation", f;
        }

        if ("production" !== process.env.NODE_ENV && "undefined" != typeof console) {
          var d = c + ":" + s;
          !n[d] && r < 3 && (L("You are manually calling a React.PropTypes validation function for the `" + l + "` prop on `" + c + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), n[d] = !0, r++);
        }
      }

      return null == a[s] ? o ? null === a[s] ? new i("The " + u + " `" + l + "` is marked as required in `" + c + "`, but its value is `null`.") : new i("The " + u + " `" + l + "` is marked as required in `" + c + "`, but its value is `undefined`.") : null : e(a, s, c, u, l);
    }

    var a = o.bind(null, !1);
    return a.isRequired = o.bind(null, !0), a;
  }

  function s(e) {
    return a(function (t, n, r, o, a, s) {
      var c = t[n];
      return l(c) !== e ? new i("Invalid " + o + " `" + a + "` of type `" + p(c) + "` supplied to `" + r + "`, expected `" + e + "`.") : null;
    });
  }

  function u(t) {
    switch (c(t)) {
      case "number":
      case "string":
      case "undefined":
        return !0;

      case "boolean":
        return !t;

      case "object":
        if (Array.isArray(t)) return t.every(u);
        if (null === t || e(t)) return !0;

        var r = function (e) {
          var t = e && (n && e[n] || e["@@iterator"]);
          if ("function" == typeof t) return t;
        }(t);

        if (!r) return !1;
        var o,
            i = r.call(t);

        if (r !== t.entries) {
          for (; !(o = i.next()).done;) {
            if (!u(o.value)) return !1;
          }
        } else for (; !(o = i.next()).done;) {
          var a = o.value;
          if (a && !u(a[1])) return !1;
        }

        return !0;

      default:
        return !1;
    }
  }

  function l(e) {
    var t = c(e);
    return Array.isArray(e) ? "array" : e instanceof RegExp ? "object" : function (e, t) {
      return "symbol" === e || !!t && ("Symbol" === t["@@toStringTag"] || "function" == typeof Symbol && t instanceof Symbol);
    }(t, e) ? "symbol" : t;
  }

  function p(e) {
    if (null == e) return "" + e;
    var t = l(e);

    if ("object" === t) {
      if (e instanceof Date) return "date";
      if (e instanceof RegExp) return "regexp";
    }

    return t;
  }

  function f(e) {
    var t = p(e);

    switch (t) {
      case "array":
      case "object":
        return "an " + t;

      case "boolean":
      case "date":
      case "regexp":
        return "a " + t;

      default:
        return t;
    }
  }

  return i.prototype = Error.prototype, r.checkPropTypes = D, r.resetWarningCache = D.resetWarningCache, r.PropTypes = r, r;
};

function U() {}

function Q() {}

Q.resetWarningCache = U;

var K = u(function (e) {
  if ("production" !== process.env.NODE_ENV) {
    var t = k;
    e.exports = z(t.isElement, !0);
  } else e.exports = function () {
    function e(e, t, n, r, o, i) {
      if (i !== _) {
        var a = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw a.name = "Invariant Violation", a;
      }
    }

    function t() {
      return e;
    }

    e.isRequired = e;
    var n = {
      array: e,
      bool: e,
      func: e,
      number: e,
      object: e,
      string: e,
      symbol: e,
      any: e,
      arrayOf: t,
      element: e,
      elementType: e,
      instanceOf: t,
      node: e,
      objectOf: t,
      oneOf: t,
      oneOfType: t,
      shape: t,
      exact: t,
      checkPropTypes: Q,
      resetWarningCache: U
    };
    return n.PropTypes = n, n;
  }();
}),
    q = !("undefined" == typeof window || !window.document || !window.document.createElement),
    ee = function () {
  function e(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  return function (t, n, r) {
    return n && e(t.prototype, n), r && e(t, r), t;
  };
}();

function te(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}

function ne(e, t) {
  if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return !t || "object" !== c(t) && "function" != typeof t ? e : t;
}

var re = function (e) {
  function t() {
    return te(this, t), ne(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
  }

  return function (e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + c(t));
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
  }(t, n.Component), ee(t, [{
    key: "componentWillUnmount",
    value: function value() {
      this.defaultNode && document.body.removeChild(this.defaultNode), this.defaultNode = null;
    }
  }, {
    key: "render",
    value: function value() {
      return q ? (this.props.node || this.defaultNode || (this.defaultNode = document.createElement("div"), document.body.appendChild(this.defaultNode)), i.createPortal(this.props.children, this.props.node || this.defaultNode)) : null;
    }
  }]), t;
}();

re.propTypes = {
  children: K.node.isRequired,
  node: K.any
};

var oe = function () {
  function e(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  return function (t, n, r) {
    return n && e(t.prototype, n), r && e(t, r), t;
  };
}();

function ie(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}

function ae(e, t) {
  if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return !t || "object" !== c(t) && "function" != typeof t ? e : t;
}

var se = function (e) {
  function t() {
    return ie(this, t), ae(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
  }

  return function (e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + c(t));
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
  }(t, n.Component), oe(t, [{
    key: "componentDidMount",
    value: function value() {
      this.renderPortal();
    }
  }, {
    key: "componentDidUpdate",
    value: function value(e) {
      this.renderPortal();
    }
  }, {
    key: "componentWillUnmount",
    value: function value() {
      i.unmountComponentAtNode(this.defaultNode || this.props.node), this.defaultNode && document.body.removeChild(this.defaultNode), this.defaultNode = null, this.portal = null;
    }
  }, {
    key: "renderPortal",
    value: function value(e) {
      this.props.node || this.defaultNode || (this.defaultNode = document.createElement("div"), document.body.appendChild(this.defaultNode));
      var t = this.props.children;
      "function" == typeof this.props.children.type && (t = n.cloneElement(this.props.children)), this.portal = i.unstable_renderSubtreeIntoContainer(this, t, this.props.node || this.defaultNode);
    }
  }, {
    key: "render",
    value: function value() {
      return null;
    }
  }]), t;
}();

se.propTypes = {
  children: K.node.isRequired,
  node: K.any
};
var ce = i.createPortal ? re : se;

function ue(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e.__proto__ = t;
}

function le(e, t) {
  return e.replace(new RegExp("(^|\\s)" + t + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}

var pe = !1,
    fe = "production" !== process.env.NODE_ENV ? K.oneOfType([K.number, K.shape({
  enter: K.number,
  exit: K.number,
  appear: K.number
}).isRequired]) : null,
    de = "production" !== process.env.NODE_ENV ? K.oneOfType([K.string, K.shape({
  enter: K.string,
  exit: K.string,
  active: K.string
}), K.shape({
  enter: K.string,
  enterDone: K.string,
  enterActive: K.string,
  exit: K.string,
  exitDone: K.string,
  exitActive: K.string
})]) : null,
    ge = n.createContext(null),
    ye = function (e) {
  function t(t, n) {
    var r;
    r = e.call(this, t, n) || this;
    var o,
        i = n && !n.isMounting ? t.enter : t.appear;
    return r.appearStatus = null, t.in ? i ? (o = "exited", r.appearStatus = "entering") : o = "entered" : o = t.unmountOnExit || t.mountOnEnter ? "unmounted" : "exited", r.state = {
      status: o
    }, r.nextCallback = null, r;
  }

  ue(t, e), t.getDerivedStateFromProps = function (e, t) {
    return e.in && "unmounted" === t.status ? {
      status: "exited"
    } : null;
  };
  var r = t.prototype;
  return r.componentDidMount = function () {
    this.updateStatus(!0, this.appearStatus);
  }, r.componentDidUpdate = function (e) {
    var t = null;

    if (e !== this.props) {
      var n = this.state.status;
      this.props.in ? "entering" !== n && "entered" !== n && (t = "entering") : "entering" !== n && "entered" !== n || (t = "exiting");
    }

    this.updateStatus(!1, t);
  }, r.componentWillUnmount = function () {
    this.cancelNextCallback();
  }, r.getTimeouts = function () {
    var e,
        t,
        n,
        r = this.props.timeout;
    return e = t = n = r, null != r && "number" != typeof r && (e = r.exit, t = r.enter, n = void 0 !== r.appear ? r.appear : t), {
      exit: e,
      enter: t,
      appear: n
    };
  }, r.updateStatus = function (e, t) {
    void 0 === e && (e = !1), null !== t ? (this.cancelNextCallback(), "entering" === t ? this.performEnter(e) : this.performExit()) : this.props.unmountOnExit && "exited" === this.state.status && this.setState({
      status: "unmounted"
    });
  }, r.performEnter = function (e) {
    var t = this,
        n = this.props.enter,
        r = this.context ? this.context.isMounting : e,
        o = this.props.nodeRef ? [r] : [i.findDOMNode(this), r],
        a = o[0],
        s = o[1],
        c = this.getTimeouts(),
        u = r ? c.appear : c.enter;
    !e && !n || pe ? this.safeSetState({
      status: "entered"
    }, function () {
      t.props.onEntered(a);
    }) : (this.props.onEnter(a, s), this.safeSetState({
      status: "entering"
    }, function () {
      t.props.onEntering(a, s), t.onTransitionEnd(u, function () {
        t.safeSetState({
          status: "entered"
        }, function () {
          t.props.onEntered(a, s);
        });
      });
    }));
  }, r.performExit = function () {
    var e = this,
        t = this.props.exit,
        n = this.getTimeouts(),
        r = this.props.nodeRef ? void 0 : i.findDOMNode(this);
    t && !pe ? (this.props.onExit(r), this.safeSetState({
      status: "exiting"
    }, function () {
      e.props.onExiting(r), e.onTransitionEnd(n.exit, function () {
        e.safeSetState({
          status: "exited"
        }, function () {
          e.props.onExited(r);
        });
      });
    })) : this.safeSetState({
      status: "exited"
    }, function () {
      e.props.onExited(r);
    });
  }, r.cancelNextCallback = function () {
    null !== this.nextCallback && (this.nextCallback.cancel(), this.nextCallback = null);
  }, r.safeSetState = function (e, t) {
    t = this.setNextCallback(t), this.setState(e, t);
  }, r.setNextCallback = function (e) {
    var t = this,
        n = !0;
    return this.nextCallback = function (r) {
      n && (n = !1, t.nextCallback = null, e(r));
    }, this.nextCallback.cancel = function () {
      n = !1;
    }, this.nextCallback;
  }, r.onTransitionEnd = function (e, t) {
    this.setNextCallback(t);
    var n = this.props.nodeRef ? this.props.nodeRef.current : i.findDOMNode(this),
        r = null == e && !this.props.addEndListener;

    if (n && !r) {
      if (this.props.addEndListener) {
        var o = this.props.nodeRef ? [this.nextCallback] : [n, this.nextCallback],
            a = o[0],
            s = o[1];
        this.props.addEndListener(a, s);
      }

      null != e && setTimeout(this.nextCallback, e);
    } else setTimeout(this.nextCallback, 0);
  }, r.render = function () {
    var e = this.state.status;
    if ("unmounted" === e) return null;
    var t = this.props,
        r = t.children,
        o = (t.in, t.mountOnEnter, t.unmountOnExit, t.appear, t.enter, t.exit, t.timeout, t.addEndListener, t.onEnter, t.onEntering, t.onEntered, t.onExit, t.onExiting, t.onExited, t.nodeRef, s(t, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]));
    return n.createElement(ge.Provider, {
      value: null
    }, "function" == typeof r ? r(e, o) : n.cloneElement(n.Children.only(r), o));
  }, t;
}(n.Component);

function be() {}

ye.contextType = ge, ye.propTypes = "production" !== process.env.NODE_ENV ? {
  nodeRef: K.shape({
    current: "undefined" == typeof Element ? K.any : K.instanceOf(Element)
  }),
  children: K.oneOfType([K.func.isRequired, K.element.isRequired]).isRequired,
  in: K.bool,
  mountOnEnter: K.bool,
  unmountOnExit: K.bool,
  appear: K.bool,
  enter: K.bool,
  exit: K.bool,
  timeout: function timeout(e) {
    var t = fe;
    e.addEndListener || (t = t.isRequired);

    for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++) {
      r[o - 1] = arguments[o];
    }

    return t.apply(void 0, [e].concat(r));
  },
  addEndListener: K.func,
  onEnter: K.func,
  onEntering: K.func,
  onEntered: K.func,
  onExit: K.func,
  onExiting: K.func,
  onExited: K.func
} : {}, ye.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: be,
  onEntering: be,
  onEntered: be,
  onExit: be,
  onExiting: be,
  onExited: be
}, ye.UNMOUNTED = "unmounted", ye.EXITED = "exited", ye.ENTERING = "entering", ye.ENTERED = "entered", ye.EXITING = "exiting";

var me = function me(e, t) {
  return e && t && t.split(" ").forEach(function (t) {
    return r = t, void ((n = e).classList ? n.classList.add(r) : function (e, t) {
      return e.classList ? !!t && e.classList.contains(t) : -1 !== (" " + (e.className.baseVal || e.className) + " ").indexOf(" " + t + " ");
    }(n, r) || ("string" == typeof n.className ? n.className = n.className + " " + r : n.setAttribute("class", (n.className && n.className.baseVal || "") + " " + r)));
    var n, r;
  });
},
    Ce = function Ce(e, t) {
  return e && t && t.split(" ").forEach(function (t) {
    return r = t, void ((n = e).classList ? n.classList.remove(r) : "string" == typeof n.className ? n.className = le(n.className, r) : n.setAttribute("class", le(n.className && n.className.baseVal || "", r)));
    var n, r;
  });
},
    ve = function (e) {
  function t() {
    for (var t, n = arguments.length, r = new Array(n), o = 0; o < n; o++) {
      r[o] = arguments[o];
    }

    return (t = e.call.apply(e, [this].concat(r)) || this).appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    }, t.onEnter = function (e, n) {
      var r = t.resolveArguments(e, n),
          o = r[0],
          i = r[1];
      t.removeClasses(o, "exit"), t.addClass(o, i ? "appear" : "enter", "base"), t.props.onEnter && t.props.onEnter(e, n);
    }, t.onEntering = function (e, n) {
      var r = t.resolveArguments(e, n),
          o = r[0],
          i = r[1] ? "appear" : "enter";
      t.addClass(o, i, "active"), t.props.onEntering && t.props.onEntering(e, n);
    }, t.onEntered = function (e, n) {
      var r = t.resolveArguments(e, n),
          o = r[0],
          i = r[1] ? "appear" : "enter";
      t.removeClasses(o, i), t.addClass(o, i, "done"), t.props.onEntered && t.props.onEntered(e, n);
    }, t.onExit = function (e) {
      var n = t.resolveArguments(e)[0];
      t.removeClasses(n, "appear"), t.removeClasses(n, "enter"), t.addClass(n, "exit", "base"), t.props.onExit && t.props.onExit(e);
    }, t.onExiting = function (e) {
      var n = t.resolveArguments(e)[0];
      t.addClass(n, "exit", "active"), t.props.onExiting && t.props.onExiting(e);
    }, t.onExited = function (e) {
      var n = t.resolveArguments(e)[0];
      t.removeClasses(n, "exit"), t.addClass(n, "exit", "done"), t.props.onExited && t.props.onExited(e);
    }, t.resolveArguments = function (e, n) {
      return t.props.nodeRef ? [t.props.nodeRef.current, e] : [e, n];
    }, t.getClassNames = function (e) {
      var n = t.props.classNames,
          r = "string" == typeof n,
          o = r ? "" + (r && n ? n + "-" : "") + e : n[e];
      return {
        baseClassName: o,
        activeClassName: r ? o + "-active" : n[e + "Active"],
        doneClassName: r ? o + "-done" : n[e + "Done"]
      };
    }, t;
  }

  ue(t, e);
  var r = t.prototype;
  return r.addClass = function (e, t, n) {
    var r = this.getClassNames(t)[n + "ClassName"],
        o = this.getClassNames("enter").doneClassName;
    "appear" === t && "done" === n && o && (r += " " + o), "active" === n && e && e.scrollTop, r && (this.appliedClasses[t][n] = r, me(e, r));
  }, r.removeClasses = function (e, t) {
    var n = this.appliedClasses[t],
        r = n.base,
        o = n.active,
        i = n.done;
    this.appliedClasses[t] = {}, r && Ce(e, r), o && Ce(e, o), i && Ce(e, i);
  }, r.render = function () {
    var e = this.props,
        t = (e.classNames, s(e, ["classNames"]));
    return n.createElement(ye, a({}, t, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  }, t;
}(n.Component);

function he(e) {
  "undefined" != typeof document && (document.documentElement.style.overflow = e ? "hidden" : "");
}

function Ie(n) {
  var i = n.open,
      c = n.portal,
      u = n.closeOnClick,
      l = n.closeOnEsc,
      p = void 0 === l || l,
      f = n.defaultPortalStyles,
      d = void 0 === f ? {
    position: "relative",
    zIndex: 999
  } : f,
      g = n.onClose,
      y = void 0 === g ? function () {
    return null;
  } : g,
      b = n.animation,
      m = void 0 === b ? {
    duration: 300,
    easing: "ease"
  } : b,
      C = n.children,
      v = function (e, t) {
    if (null == e) return {};
    var n,
        r,
        o = s(e, t);

    if (Object.getOwnPropertySymbols) {
      var i = Object.getOwnPropertySymbols(e);

      for (r = 0; r < i.length; r++) {
        n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
      }
    }

    return o;
  }(n, ["open", "portal", "closeOnClick", "closeOnEsc", "defaultPortalStyles", "onClose", "animation", "children"]),
      h = r(null);

  return !c && h && h.current && d && Object.keys(d).forEach(function (e) {
    h.current.defaultNode.style[e] = d[e];
  }), he(!!i), o(function () {
    function e(e) {
      "Escape" === e.key && p && y();
    }

    return document.addEventListener("keydown", e), document.removeEventListener("keydown", e);
  }, [p]), e(ce, a({
    ref: h
  }, c ? {
    node: c
  } : {}), e(ve, {
    in: i,
    classNames: "overlay",
    unmountOnExit: !0,
    timeout: m.duration
  }, e("div", a({
    css: t("position:fixed;top:0;left:0;width:100%;height:100%;overflow:scroll;transition:opacity ", m.duration, "ms ", m.easing, ";-webkit-overflow-scrolling:touch;&.overlay-enter-done{opacity:1;}&.overlay-exit,&.overlay-enter{opacity:0;};label:Overlay;" + ("production" === process.env.NODE_ENV ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")),
    onClick: function onClick(e) {
      u && (e.preventDefault(), e.target === e.currentTarget && y());
    }
  }, v), C)));
}

ve.defaultProps = {
  classNames: ""
}, ve.propTypes = "production" !== process.env.NODE_ENV ? a({}, ye.propTypes, {
  classNames: de,
  onEnter: K.func,
  onEntering: K.func,
  onEntered: K.func,
  onExit: K.func,
  onExiting: K.func,
  onExited: K.func
}) : {};
export { Ie as Overlay };